import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Users, Settings, Plus, BarChart3, MessageSquare, Building2 } from 'lucide-react';

const navigation = [
  { id: 'dashboard', name: 'Dashboard', icon: LayoutDashboard, path: '/app/dashboard' },
  { id: 'invoices', name: 'Invoices', icon: FileText, path: '/app/invoices' },
  { id: 'clients', name: 'Clients', icon: Users, path: '/app/clients' },
  { id: 'analytics', name: 'Analytics', icon: BarChart3, path: '/app/analytics' },
  { id: 'chat', name: 'Team Chat', icon: MessageSquare, path: '/app/chat' },
  { id: 'workspaces', name: 'Workspaces', icon: Building2, path: '/app/settings/workspaces' },
  { id: 'settings', name: 'Settings', icon: Settings, path: '/app/settings' },
];

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/app/settings/workspaces') {
      return location.pathname === path;
    }
    return location.pathname === path || (path === '/app/dashboard' && location.pathname === '/app');
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 min-h-screen">
      <div className="p-6">
        <button
          onClick={() => navigate('/app/invoices/new')}
          className="w-full flex items-center justify-center px-4 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all transform hover:scale-105 font-medium shadow-lg"
        >
          <Plus className="h-5 w-5 mr-2" />
          New Invoice
        </button>
      </div>

      <nav className="px-3">
        <ul className="space-y-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <li key={item.id}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-all ${
                    active
                      ?  'bg-green-50 text-green-700 border-r-2 border-green-600 shadow-sm'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className="h-5 w-5 mr-3" />
                  {item.name}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Upgrade Banner */}
      <div className="p-4 m-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200">
        <h3 className="text-sm font-semibold text-green-900 mb-1">Upgrade to Pro</h3>
        <p className="text-xs text-green-700 mb-3">Unlock unlimited invoices and advanced features</p>
        <button className="w-full px-3 py-2 bg-green-600 text-white text-xs font-medium rounded-md hover:bg-green-700 transition-colors">
          Upgrade Now
        </button>
      </div>
    </div>
  );
}